<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('general.payment_record') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
        </li>

        <li class="breadcrumb-item">{{ $t('general.payment_record') }}</li>
      </ol>
    </div>

    <SinglePreapprovedInvoiceRow v-if="invoiceType !='simple'" :fetch-data="fetchData"/>
    <SingleInvoiceRow v-else :fetch-data="fetchData" />
    <SingleRequestRow v-if="prepaymentRequestShow" :prepayment-request="prepaymentRequest"/>
    <SinglePaymentRow :payment-data="paymentData"/>
  </div>

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import SingleRequestRow from '../prepayments/SinglePrepaymentRequestRow'
import SinglePaymentRow from './SinglePaymentRow'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')
export default {
  components: { MultiSelect, SingleInvoiceRow, SingleRequestRow, SinglePaymentRow, SinglePreapprovedInvoiceRow
  },
  mixins: [validationMixin],
  data () {
    return {
      userType: null,
      fetchData: [],
      prepaymentRequest: [],
      paymentData: [],
      isLoading: false,
      prepaymentRequestShow: false,
      invoiceType: 'simple'

    }
  },
  created () {
    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') == 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') == 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') == 'funder') {
      this.userType = 'funder'
    }
    this.loadData()
    this.loadInvoice()
    this.loadRequest()
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('prepayment', [
      'fetchPrePaymentRequest',
      'fetchPrePayment'
    ]),
    ...mapActions('payment', [
      'fetchPaymentThroughInvoice'
    ]),
    async loadData () {
      let response = await this.fetchPaymentThroughInvoice(this.$route.params.id)
      if (response.data) {
        this.paymentData = response.data.payment
      }
    },
    async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.invoice
        this.invoiceType = response.data.invoice[0].invoiceType
      }
    },
    async loadRequest () {
      if (this.$route.params.id) {
        let res = await this.fetchPrePaymentRequest(this.$route.params.id)
        if (res.data.result === 'success') {
          this.prepaymentRequest = res.data.prepaymentRequest
          if (this.prepaymentRequest.length > 0) {
            this.prepaymentRequestShow = true
          }
        }
      }
    }
  }

}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
